"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
const styles_1 = require("@material-ui/core/styles");
exports.useStyles = (0, styles_1.makeStyles)((theme) => ({
    menuBarWrapper: {
        borderBottom: '1px solid #e7e7e7',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        backgroundColor: theme.palette.primary.main,
        top: 0,
        width: '100%',
        minHeight: 63,
        padding: '0',
    },
    menuBarTitle: {
        '& > :not(:last-child)': {
            display: 'none',
        },
        color: 'white',
        fontSize: '14px',
        fontWeight: 'inherit',
        letterSpacing: '0.2px',
        padding: 0,
    },
    menuBarButton: {
        minWidth: 'auto',
        padding: '0',
    },
    iconlink: {
        display: 'block',
        width: 62,
        height: 62,
        zIndex: 99,
        cursor: 'pointer',
        color: 'white',
        flex: '0 0 auto',
        padding: 8,
    },
    drawerHeader: {
        padding: 0,
    },
    drawerUserInfo: {
        backgroundColor: 'white',
        color: 'black',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '0 1rem',
        height: '62px',
    },
    drawerDivider: {
        backgroundColor: theme.palette.primary.main,
        color: 'white',
        padding: '0 1rem',
    },
    drawerTitle: {
        color: 'black',
        fontSize: '14px',
        fontWeight: 'inherit',
        letterSpacing: '0.2px',
    },
}));
//# sourceMappingURL=drawer-styles.js.map